import { Bar } from 'react-chartjs-2';
import { baseBarOptions, CHART_COLORS, round } from '../../../config/chart-config';
import { darkenHex } from '../../../helpers';

const OtherChart = ({ labels, values }) => {
    if (!values?.length) return null;

    const data = {
        labels,
        datasets: [
            {
                label: 'gram',
                data: values.map(round),
                backgroundColor: CHART_COLORS.blue,
                hoverBackgroundColor: darkenHex(CHART_COLORS.blue, 0.1)
            }
        ]
    };

    const options = {
        ...baseBarOptions,
        scales: {
            ...baseBarOptions.scales,
            y: {
                ...baseBarOptions.scales.y,
                title: { display: true, text: 'gram' }
            }
        }
    };

    return (
        <div className="chart-wrapper">
            <span>Övriga ämnen</span>
            <div className="chart-inner">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default OtherChart;
